module.exports = __webpack_public_path__ + "media/images/okra-offers/googleplay-bd5102beff578dbac815d82a48071329.png";